import Vue from "vue";
import Router from "vue-router";
import { DefaultLayout } from "@/layouts";
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import store from './store'
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

Vue.use(Router);

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },


  routes: [
    // {
    //   path: '/',
    //   name: 'Public',
    //   component: () => import( /* webpackChunkName: "about" */"./components/Public"),
    // },
    {
      path: '/Public',
      name: 'Public',
      component: () => import( /* webpackChunkName: "about" */"./components/Public"),
      meta: {
        isPublic: true,
        requiresAuth: false
      }
    },
    {
      path: '/Cumplimiento',
      name: 'Cumplimiento',
      component: () => import(/* webpackChunkName: "about" */ './components/Cumplimiento.vue')
    },
   
    {
      path: '/Addformato',
      name: 'Addformato',
      component: () => import(/* webpackChunkName: "about" */ "./components/AddFormato")
    },
    // {
    //     path: "/",
    //     component: DefaultLayout,
    //     children: [
    //       {
    //         path: "",
    //         name: "dashboard",
    //         component: () => import(/* webpackChunkName: "about" */ "./components/Public"),
          
    //       }
    //     ]
    // },
   
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './components/Home.vue')
    },
 
    {
      path: '/CatFraccion',
      name: 'CatFraccion',
      component: () => import(/* webpackChunkName: "about" */ "./components/CatFraccion")
    },
    {
      path: '/DtUnidad',
      name: 'DtUnidad',
      component: () => import(/* webpackChunkName: "about" */ "./components/DtUnidad.vue")
    },
    {
      path: '/CatPeriodo',
      name: 'CatPeriodo',
      component: () => import(/* webpackChunkName: "about" */ "./components/CatPeriodo")
    },
    {
      path: '/CatUsuarios',
      name: 'Usuarios',
      component: () => import(/* webpackChunkName: "about" */ "./components/usuarios")
    },
    {
      path: '/CatArchivo/:id',
      name: 'Archivos',
      component: () => import(/* webpackChunkName: "about" */ "./components/CatArchivo"),
      meta: {
        isPublic: true
      }
    },
    {
      path: '/oidc-callback', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
      name: 'oidcCallback',
      component: () =>
      import(/* webpackChunkName: "oidc" */ './views/oidc/OidcCallback'),
      meta: {
        isOidcCallback: true,
        isPublic: true
      }
    }, 
    {
      path: '/oidc-callback-error', // Needs to match redirect_uri in you oidcSettings
      name: 'oidcCallbackError',
      component: () => import(/* webpackChunkName: "oidc_error" */ './views/oidc/OidcCallbackError'),
      meta: {
        isPublic: true
      }, 
      path: '/PubFracciones/:id',
      name: 'PubFracciones',
      component: () => import(/**/ "./components/PubFracciones"),
     
    },
  
  ]
});
 
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

router.beforeEach((to, from, next) => {
  NProgress.start();
//   if (currentUser.role) {
//     // role not authorised so redirect to home page
//     return next({ path: '/' });
// }
  next();
});

router.afterEach(() => {
  NProgress.done();
});
export default router;